import ParameterErrors from '../errors/ParameterErrors';
import Validation from '../validation/Validation';
const { throwIsNotNumber } = ParameterErrors;
export default class Vector2 {
    constructor(props) {
        const { x, y } = props;
        if (!Validation.isNumber(x)) throwIsNotNumber("x");
        if (!Validation.isNumber(y)) throwIsNotNumber("y");
        this._x = x;
        this._y = y;
		this.toArray = this.toArray.bind(this);
    }
    get x() {
        return this._x;
    }
    get y() {
        return this._y;
    }
	toArray(){
		return [this._x, this._y];
	}
    static fromArray(arr) {
        return new Vector2({
            x: arr[0],
            y: arr[1]
        })
    }
    static fromObj(obj) {
        return new Vector2(obj);
    }
}
